const mutations = {
    SET_ERROR_BLOGS(state, payload) {
        state.error = payload;
    }
};

export default mutations;
